function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { omit, pick, get } from 'lodash';
import EBPropTypes from 'js-utils/prop-types';
import VectorImage from '../vectorImage/VectorImage';
import * as constants from './constants';
import { getIconVectorType, iconNameMatches } from './util';

var Icon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Icon).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          size = _this$props.size,
          color = _this$props.color,
          strokeColor = _this$props.strokeColor;
      var vectorImageProps = pick.apply(void 0, [this.props].concat(_toConsumableArray(Object.keys(VectorImage.propTypes))));
      var overrideColor = color;
      var overrideStrokeColor = strokeColor; // Default the color to a theme color no color has been specified.
      // This way the icons will be themable
      // NOTE: Below is commented out until we can properly theme all
      // the places icons are used (EB-99689)
      // if (!overrideColor && !overrideStrokeColor) {
      //     overrideColor = 'ui-700';
      // }
      // Clear out defaulted color for logo icons

      if (!color && iconNameMatches(type, function (name) {
        return name.startsWith('logo-');
      })) {
        overrideColor = undefined;
      } // if the icon type is one that should use a stroke color instead of fill
      // color, replace the fill color with the stroke color


      if (!strokeColor) {
        var isStrokeIcon = !!constants.STROKE_COLOR_ICONS.find(function (strokeColorIcon) {
          return strokeColorIcon.displayName === get(type, 'type.displayName');
        });

        if (isStrokeIcon) {
          overrideStrokeColor = overrideColor;
          overrideColor = undefined;
        }
      }

      return React.createElement(VectorImage, _extends({}, vectorImageProps, {
        type: getIconVectorType(type),
        svg: type,
        size: size,
        color: overrideColor,
        strokeColor: overrideStrokeColor
      }));
    }
  }]);

  return Icon;
}(PureComponent);

_defineProperty(Icon, "propTypes", _objectSpread({}, omit(VectorImage.propTypes, ['svg', 'type']), {
  /**
   * The type of icon that you want to display e.g. alert
   */
  type: constants.ICON_TYPE_PROP_TYPE.isRequired,

  /**
   * The size of the icon
   */
  size: PropTypes.oneOf(constants.SIZES),

  /**
   * The fill color of the icon
   */
  color: constants.COLOR_PROP_TYPE,

  /**
   * The stroke color of the icon
   */
  strokeColor: constants.COLOR_PROP_TYPE,

  /**
   * The title of the icon
   */
  title: EBPropTypes.translation
}));

_defineProperty(Icon, "defaultProps", {
  size: 'small'
});

export { Icon as default };